/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LazyImg from 'react-lazyload-image';
import './Image.css';
import { addBackgroundPropertyToPage, addBackgroundImageToPage } from '../../redux/actions/entities/pages';


class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDropped: false,
    };
  }

  selectCategory = () => {
    const {
      category, currentPage, layouts, backgrounds, image,
    } = this.props;
    this.props.dispatch(addBackgroundPropertyToPage(currentPage.id, 'category', category));
    setTimeout(() => {
      this.props.dispatch(addBackgroundImageToPage(image.images[0].parentCategory, layouts, backgrounds.backgrounds, image.images[0].fileName));
    }, 0);
  }

  render() {
    const { thumb } = this.props;

    return (
      <div onClick={this.selectCategory} className="Image">
        <LazyImg
          src={thumb}
          scroller=".GalleryWrapper"
        />
      </div>);
  }
}

Image.defaultProps = {
  thumb: '',
  category: '',
  dispatch: () => {},
  currentPage: {},
};


Image.propTypes = {
  thumb: PropTypes.string,
  category: PropTypes.string,
  dispatch: PropTypes.func,
  currentPage: PropTypes.object,
};

export default connect(state => ({
  pages: state.entities.pages.byId,
  backgrounds: state.backgrounds,
  layouts: state.entities.layouts.byId,
}
))(Image);



// WEBPACK FOOTER //
// ./src/components/image/Image.jsx